import { cn } from "../lib/utils";

/**
 * Consistent empty-state across all data pages.
 * Use when a list/table/section has zero items and we want to guide
 * the user to a first meaningful action.
 *
 * <EmptyState
 *   icon={AlertTriangle}
 *   title="No risks registered yet"
 *   description="Start tracking risks across your assets."
 *   action={<Button>+ Add your first risk</Button>}
 * />
 */
export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
  variant = "card",
}) {
  const content = (
    <div className="flex flex-col items-center justify-center text-center py-12 px-6">
      {Icon && (
        <div className="rounded-full bg-muted p-4 mb-4" aria-hidden="true">
          <Icon className="w-8 h-8 text-muted-foreground" />
        </div>
      )}
      <h3 className="font-heading text-lg font-semibold mb-1">{title}</h3>
      {description && (
        <p className="text-sm text-muted-foreground max-w-sm mb-6">{description}</p>
      )}
      {action}
    </div>
  );

  if (variant === "bare") return <div className={className}>{content}</div>;

  return (
    <div
      className={cn(
        "rounded-lg border border-dashed border-border bg-card",
        className,
      )}
    >
      {content}
    </div>
  );
}
